import moment from 'moment';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { open } from 'store/modules/modal';

import Games from '../components/Games';
import API from '../../../../utils/api';

const refreshLists = async (props, leagueId, month, teamId) => {
  try {
    const curMonth = month ? month : moment();
    let selectedLeague = null;

    const team = teamId !== undefined ? teamId : props.teamSelected;
    let filterActive = { active: true };
    await API.getLeagues({
      ignoreDependencies: true,
      query: JSON.stringify(filterActive),
    }).then(({ data }) => {
      const leagues = data.docs;
      if (leagues.length > 0) {
        props.setLeagueList(leagues ? leagues : []);

        if (leagueId) {
          if (typeof leagueId === 'object') {
            leagueId = leagueId._id;
          }
          leagues.forEach(league => {
            if (league._id.toString() === leagueId) {
              selectedLeague = league;
            }
          });
        } else {
          selectedLeague = props.selectedLeague ? props.selectedLeague : leagues[0];
        }

        props.setLeagueSelected(selectedLeague);
        if (selectedLeague) {
          props.setHomePosition(
            selectedLeague && selectedLeague.homePosition
              ? selectedLeague.homePosition
              : 'left'
          );
          props.setScheduleImageUrl(selectedLeague.scheduleImage);
        }
      }
    });

    const query = {
      leagueId: selectedLeague ? selectedLeague._id : null,
      month: new Date(curMonth),
      localOffset: moment(curMonth).utcOffset(),
      team,
      getEventList: true,
    };

    await API.getSchedule(query).then(data => {
      const eventList = data.eventList;
      for (const e of eventList) {
        e.start = moment(e.start);
        e.end = moment(e.end);
      }
      props.setGameEvents(eventList);
      props.setTeamSelected(team);
    });
    let queryTeams = { leagues: selectedLeague ? selectedLeague._id : null };
    queryTeams = JSON.stringify(queryTeams);
    await API.getTeams({ query: queryTeams, ignoreDependencies: true }).then(
      ({ data }) => {
        if (data && data.docs) {
          props.setTeams(data.docs);
        }
      }
    );
  } catch (error) {
    console.error(error);
  }
};

const fetchDailyGames = async (props, date, league) => {
  try {
    if (date && league) {
      const localOffset = moment(date).utcOffset();
      const query = {
        leagueId: league ? league._id : null,
        singleDay: new Date(date),
        localOffset: localOffset,
      };

      API.getSchedule(query).then(data => {
        if (data && data.gameList) {
          props.setGames(data.gameList);
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('leagues', 'setLeagueList', []),
  withState('games', 'setGames', []),
  withState('gameEvents', 'setGameEvents', []),
  withState('teams', 'setTeams', []),
  withState('homePosition', 'setHomePosition', 'left'),
  withState('leagueSelected', 'setLeagueSelected', null),
  withState('scheduleImageUrl', 'setScheduleImageUrl', ''),
  withState('teamSelected', 'setTeamSelected', null),
  withState('targetMonth', 'setTargetMonth', null),
  withState('dialogOpen', 'setDialogOpen', false),
  withState('errorList', 'setErrorList', { teams: '', time: '' }),
  withHandlers({
    changeFilter:
      props =>
      ({ league, team }) => {
        if (!league) {
          league = props.leagueSelected;
        }
        refreshLists(
          props,
          league,
          props.targetMonth,
          league !== undefined && league !== props.leagueSelected ? null : team
        );
      },
    getDailyEvents: props => date => {
      fetchDailyGames(props, date, props.leagueSelected);
    },
    updateCalendarEvents: props => month => {
      props.setTargetMonth(month);
      refreshLists(props, props.leagueSelected, month);
    },
    refresh: props => daySelected => {
      refreshLists(props, props.leagueSelected, props.targetMonth);
      fetchDailyGames(props, daySelected, props.leagueSelected);
    },
    createGame: props => (newGame, daySelected) => {
      API.createGame(newGame).then(() => {
        refreshLists(props, props.leagueSelected, props.targetMonth);
        fetchDailyGames(props, daySelected, props.leagueSelected);
      });
    },
    editGame: props => (game, daySelected) => {
      API.editGame(game.id, game).then(() => {
        refreshLists(props, props.leagueSelected, props.targetMonth);
        fetchDailyGames(props, daySelected, props.leagueSelected);
      });
    },
    confirmDeleteGame: props => (row, homePosition, date) => {
      props.dispatch(
        open({
          modalType: 'confirm',
          modalProps: {
            message: `Delete Game:  ${row[homePosition.left]} vs ${
              row[homePosition.right]
            }?`,
            keyId: row.id,
            handleYes: () => {
              API.deleteGame(row._id).then(() => {
                refreshLists(props, props.leagueSelected, props.targetMonth);
                fetchDailyGames(props, date, props.leagueSelected);
              });
            },
          },
        })
      );
    },
    changeDialogState: props => state => {
      props.setDialogOpen(state);
      props.setErrorList({ teams: '', time: '' });
    },
    updateErrorMessage: props => (field, message) => {
      const errors = props.errorList;
      errors[field] = message;
      props.setErrorList(errors);
    },
  }),
  lifecycle({
    componentDidMount() {
      refreshLists(this.props);
    },
    componentWillUnmount() {},
  })
);

export default enhance(Games);
